<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <input
            :id="fullFormIdentifier"
            v-model="telephone"
            :class="{ 'form-element__input--active': telephone !== '' }"
            class="form-element__input"
            type="tel"
            :data-validate="validation"
            :data-nullable="validationNullable"
            :data-validate-message="validationMessage"
            :data-error-target="fullFormIdentifier + '-container'"
            name="telephone"
            autocomplete="off"
            :placeholder="placeholder"
        />
    </div>
</template>

<script>
    export default {
        props: {
            formIdentifier: {
                type: String,
                default: "form",
            },
            inputValidate: {
                type: Boolean,
                default: true,
            },
            inputNullable: {
                type: Boolean,
                default: true,
            },
            inputValidateMessage: {
                type: String,
                default: "",
            },
        },
        computed: {
            telephone: {
                get: function () {
                    return this.$store.state.CustomerData.telephone;
                },
                set: function (newValue) {
                    this.$store.dispatch("CustomerData/storeCustomerData", { telephone: newValue });
                },
            },
            validation() {
                if (this.inputValidate) {
                    return "tel";
                }
                return false;
            },
            placeholder(){
                return 'Telephone ' + this.validationStar
            },
            validationStar() {
                if (!this.inputNullable) {
                    return "*";
                }
                return "";
            },
            validationNullable() {
                if (this.inputNullable) {
                    return 1;
                }
                return false;
            },
            validationMessage() {
                if (this.inputValidateMessage) {
                    return this.inputValidateMessage;
                }
                return false;
            },
            fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
    };
</script>